/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
 */
import React from 'react';
import SvgIcon from '../../../../svg-icon/SvgIcon';
import accessibleIcon from '../../../../accessible-icon/accessible-icon';

var MagnifyingGlassIcon = function MagnifyingGlassIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-720.000000, -18.000000)",
    fill: "#3b3331"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(659.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.633175,17.9638111 L14.1574098,12.4856873 C15.1389485,11.1469131 15.664755,9.52836696 15.6574238,7.86831972 C15.6386954,3.53504559 12.1339938,0.0251075646 7.80092209,7.96007691e-05 C5.72730302,-0.00930269987 3.73605767,0.81105703 2.27077918,2.27840585 C0.805500694,3.74575466 -0.0120928677,5.73820252 0.000135215858,7.8118884 C0.0188635483,12.145557 3.52388496,15.6558148 7.85735118,15.6808428 C9.52409554,15.688067 11.1484911,15.1561022 12.4881086,14.1643404 L12.4938229,14.1600545 L17.9645881,19.6338924 C18.2603749,19.9442125 18.7011175,20.0698227 19.1160487,19.9620551 C19.5309799,19.8542875 19.8549019,19.5300753 19.9623101,19.1150357 C20.0697184,18.6999962 19.9437359,18.2593439 19.633175,17.9638111 L19.633175,17.9638111 Z M7.85163685,14.1121951 C4.38505325,14.0922527 1.58108171,11.284347 1.56586407,7.81760296 C1.55650769,6.15886911 2.21063635,4.56523094 3.38263843,3.3914386 C4.55464052,2.21764625 6.14724151,1.56112283 7.80592213,1.56801306 C11.2725057,1.58795544 14.0764773,4.39586112 14.0916949,7.86260515 C14.1010513,9.521339 13.4469226,11.1149772 12.2749205,12.2887695 C11.1029185,13.4625619 9.51031747,14.1190853 7.85163685,14.1121951 Z"
  }))))));
};

MagnifyingGlassIcon.defaultProps = {
  width: '20px',
  height: '20px',
  viewBox: '0 0 20 20'
};
export default /*#__PURE__*/React.memo(accessibleIcon(MagnifyingGlassIcon));